import { Component, OnChanges, Input, Output, OnInit, OnDestroy, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../services/language.service';

import { MatDialog } from '@angular/material/dialog'

import { ContactesService } from '../services/contactes/contactes.service';
import { NotesServiceContactes } from '../dialog/notes_contactes/notes.service_contactes';
import { DialogContactes } from '../dialog/contactes/dialog.component.contactes';
import { DialogNotesContactes } from '../dialog/notes_contactes/dialog.component.notes_contactes';

import { IFRNotes, IFRNota } from '../notes/notes.interfaces';
import { ListContactesService } from './list.service';
import { saveAs } from 'file-saver';

import { IContactes, IContactesResponse } from './contactes.interfaces';
import { TokenStorageService } from '../services/auth-user-service/token-storage.service';

import { fromEvent, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { StripHtmlPipe } from '../pipes/stripHTMLpipe';

@Component({
  selector: 'mcrit-gestio-contactes',
  templateUrl: './contactes.component.html',
  styleUrls: ['./contactes.component.css'],
  providers: [StripHtmlPipe, ContactesService, NotesServiceContactes, ListContactesService]
})
export class ContactesComponent implements OnInit, OnDestroy {
  public showAsyncProgress: boolean = false;
  public contactesData: IContactesResponse;
  public editNotesData: IFRNota;
  public userInfo: any = {};
  
  private activeFilters: any = {};
  private currentOrdering: any = {};
  private orderingCycle: Array<string> = ['', 'ASC', 'DESC'];

  public firstRegisterShown: number = 0;
  public lastRegisterShown: number;
  public rowsPerPageOptions: Array<number> = [5, 10, 20, 50, 100, 200, 500, 1000, 10000];
  private unsubscriber : Subject<void> = new Subject<void>();
  public showFilters: boolean = true;
  public export: boolean = false;
  public orderingParameters: any;

  private contactesModel: IContactes = {
    'id': 'NEW',
    'nom': null,
    'tipus': null,
    'email': null,
    'tlf': null,
//    'skype': null,
    'linkedin': null,
    'mobil': null,
    'comentari': null,
    'empresa': null,
    'ambit': null,
    'adreca': null,
    'id_client': null,
    'professional': null,
    'nota': null,
    'data_nota': null,
    'pais': null,
    'tematica1': null,
    'tematica2': null,
    'tematica3': null,
    'tematica4': null,
    'tematica5': null
  };
  private notesModel: IFRNota = {
     'id': 'NEW',
     'data': null,
     'observacions': null,
     'nota_e': null,
     'taula': null
  };
  public error: string = '';
  public showDialog: boolean = false;
  public editContacteData: IContactes;

  public exportar(){this.export=true;this.requestRowsToParent();};

  private convertToCSV(objArray) {
    var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
    var str = '';
    var row = "";

    for (var index in objArray[0])row += index + ';';
    row = row.slice(0, -1);
    str += row + '\r\n';

    for (var i = 0; i < array.length; i++) {
        var line = '';
        for (var index in array[i]) {
            if (line != '') line += ';'
            line += array[i][index];
        }
        str += line + '\r\n';
    }
    return str;
  }

 // public navigateToContacte(idContacte){this.router.navigate(['fitxaContactes', idContacte]);}

  public addContacte(): void {
    this.editContacteData = Object.assign( {}, this.contactesModel, { id : 'NEW' } );
    let dialogFactRef=this.dialog.open(DialogContactes, {disableClose: true, height: '590px', data: {dades: this.editContacteData, user: this.userInfo} })
   
    dialogFactRef.afterClosed().subscribe(results => {
      if(!results)return;
      this.editContacteData = results;
      this.addOrUpdate();
    });
    //this.showDialog = true;
  }

  public editContacte(contacte: IContactes): void {
    this.editContacteData = Object.assign( {}, this.contactesModel, contacte );
    let dialogFactRef=this.dialog.open(DialogContactes, {height: '590px', data: {dades: this.editContacteData, user: this.userInfo} })

    dialogFactRef.afterClosed().subscribe(results => {
      if(!results)return;
      this.editContacteData = results;
      this.addOrUpdate();
    });
  }

  public addOrUpdate(): void {
    this.showAsyncProgress = true;

    if (this.editContacteData.id === 'NEW') {
      this.contactesService.create(this.editContacteData)
        .subscribe(newContacte => {console.log("S'ha creat l'element");this.router.navigate(['contactes']);});
    } else {
      this.contactesService.update(<number> this.editContacteData.id, this.editContacteData)
        .subscribe(updatedContacte => {console.log("S'han desat les dades");this.router.navigate(['contactes']);});
        //Actualitza la llista amb les modificacions
        let updateItem = this.contactesData.rows.find(item => item.id == this.editContacteData.id);
        let index = this.contactesData.rows.indexOf(updateItem);
        this.contactesData.rows[index] = this.editContacteData;
    }
  }

 public editNota(id, nota, nom): void {
    this.editNotesData = Object.assign(this.notesModel);
    this.editNotesData.id = id;
    this.editNotesData.observacions = nota;
    this.editNotesData.taula = nom;

    let dialogFactRef=this.dialog.open(DialogNotesContactes, {disableClose: true, height: '590px', width: '1200px', data: {nota: this.editNotesData, user: this.userInfo}})
   
    dialogFactRef.afterClosed().subscribe(results => {
      if(!results)return;
      this.editNotesData = results;
      this.addOrUpdateNotes();
    });
  }

  public addOrUpdateNotes(): void {
    this.showAsyncProgress = true;
    this.notesServiceContactes.updateNota(this.editNotesData)
      .subscribe(updatedNota => {console.log("S'han desat les dades");this.requestRowsToParent();this.showAsyncProgress = false;});
  }

  public gotoPage(page: number): void {
    this.listContactesService.currentPage = page;
    this.computeDisplayedRows();
    this.requestRowsToParent();
  }

  public toggleFiltersVisibility() {
     this.showFilters = !this.showFilters;
  }

  public computeActiveFilters($event){
    if(this.currentOrdering.length == 0)['nom'].map(item => this.currentOrdering[item] = this.orderingCycle[1]);
    this.activeFilters = $event;
    this.firstRegisterShown = 1 + this.listContactesService.currentPage * this.listContactesService.rowsPerPage;
    this.requestRowsToParent();
   }

  public cycleOrdering(key) {
    let i = this.orderingParameters[key]?this.orderingParameters[key]:0;

    this.orderingParameters = {};
    this.orderingParameters[key] = (1 + i) % this.orderingCycle.length;

    this.currentOrdering = {};
    this.currentOrdering[key] = this.orderingCycle[this.orderingParameters[key]];

    this.requestRowsToParent();
  }

   private computeDisplayedRows(): void {
    this.firstRegisterShown = 1 + this.listContactesService.currentPage * this.listContactesService.rowsPerPage;
    this.lastRegisterShown = Math.min(this.firstRegisterShown + this.listContactesService.rowsPerPage - 1, this.contactesData.registers);
   }

   private requestRowsToParent(): void {
    this.contactesService.getList(
      this.listContactesService.rowsPerPage, //Limit
      this.listContactesService.currentPage*this.listContactesService.rowsPerPage, //Skip
      this.activeFilters //FILTRE DELS CONTACTESS QUE ES MOSTREN A INICI
      ,{}//Conds a aplicar. Per defecte LIKE %%
      ,this.currentOrdering //ORDRE DELS CONTACTES QUE ES MOSTREN A INICI
      ,this.export
    ).subscribe(
      data => {
        if(!this.export){this.contactesData = data;this.computeDisplayedRows();}
        else{
          var csvData = this.convertToCSV(data.rows);
          var file = new Blob(["\ufeff",csvData], { type: 'text/csv;charset=utf-8' });
          saveAs(file, "export.csv");
        }
      },
      error => console.log(error)
    );
   }

   public requestPrevious(): void {
     this.listContactesService.currentPage = Math.max(0, this.listContactesService.currentPage - 1);
     this.computeDisplayedRows();
     this.requestRowsToParent();
   }

   public requestNext(): void {
     this.listContactesService.currentPage = this.listContactesService.currentPage + 1;
     this.computeDisplayedRows();
     this.requestRowsToParent();
   }

   public setRowPerPage(rowsPerPage: number) {
     this.listContactesService.rowsPerPage = rowsPerPage;
     this.requestRowsToParent();
   }

  public contactesFilters: Array<any>
  public ordreCamps: Array<any>
  public tableFields: Array<any>

  constructor(public translate: TranslateService, public languageService: LanguageService, public striphtml:StripHtmlPipe, public tokenStorage: TokenStorageService, public listContactesService: ListContactesService, public dialog:MatDialog, private contactesService: ContactesService, private router: Router, private notesServiceContactes: NotesServiceContactes) { 
  this.userInfo = this.tokenStorage.getUser();}

  private buildStaticData(): void {
    this.tableFields = [
      ['nom', this.translate.instant('usuaris.colNom')],
      ['empresa', this.translate.instant('facturacio.camps.empresa')],
      ['tipus', this.translate.instant('usuaris.colCarrec')],
      ['email', this.translate.instant('clientsSocis.cmpmail')],
      ['tlf', this.translate.instant('usuaris.colTelefon')],
    ];

    this.contactesFilters = [
      {
        inputs: []
      },
      {
        inputs: [
          {
            name: 'text',
            type: 'text',
            values: [
              {
                text: this.translate.instant('usuaris.colNom'), //Text a mostrar label
                name: 'nom', //Camp de la base de dades
                autocomplete: 'contacte', //Crida per obtenir els valors si autocomplete
                value: this.listContactesService.getSearchValues('nom') //valor a mostrar
              },
              {
                text: this.translate.instant('facturacio.camps.empresa'),
                name: 'empresa',
                autocomplete: 'clientsSocis',
                value: this.listContactesService.getSearchValues('empresa')
              },
              {
                text: this.translate.instant('propostaMi.camps.ambit'),
                name: 'ambit',
                autocomplete: 'ambitCont',
                value: this.listContactesService.getSearchValues('ambit')
              }
            ]
          }
        ]
      }
    ];

    this.orderingParameters = this.tableFields.reduce((acum, curr) => {
      acum[curr[0]] = 0;
      return acum;
    }, {});
  }

  ngOnInit() {
    this.ordreCamps = ['nom'];

    this.buildStaticData();

    // Si l'usuari canvia d'idioma en calent, reconstruïm capçaleres i filtres
    this.translate.onLangChange
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(() => this.buildStaticData());

    ['con.id'].map(item => this.currentOrdering[item] = this.orderingCycle[2]);
    this.computeActiveFilters({});
 
     history.pushState(null,  document.title, location.href);

    fromEvent(window, 'popstate').pipe(
      takeUntil(this.unsubscriber)
    ).subscribe((_) => {
      history.pushState(null, '');
    });

  }

    ngOnDestroy(): void {
      this.unsubscriber.next();
      this.unsubscriber.complete();
    }

}
